export default __webpack_public_path__ + "static/media/centro_almagro.f2313386.jpg";